import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolder2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconFolder2"><Path d="M2 4.75C2 3.7835 2.7835 3 3.75 3H9.53823C9.99406 3 10.4319 3.17786 10.7586 3.49573L12.2319 4.92918C12.2785 4.97459 12.3411 5 12.4062 5H20.25C21.2165 5 22 5.7835 22 6.75V9.12803C21.7654 9.04512 21.513 9 21.25 9H2.75C2.48702 9 2.23458 9.04512 2 9.12803V4.75Z" fill="currentColor"/><Path d="M2 11.25V18.25C2 19.2165 2.7835 20 3.75 20H20.25C21.2165 20 22 19.2165 22 18.25V11.25C22 10.8358 21.6642 10.5 21.25 10.5H2.75C2.33579 10.5 2 10.8358 2 11.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolder2;
